"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var actions_1 = require("./actions");
exports.default = (0, utils_1.makeGenericNetworkReducer)(actions_1.FETCH_CATEGORIES, actions_1.ADD_CATEGORY, actions_1.UPDATE_CATEGORY, actions_1.DELETE_CATEGORY);
